import { createTrackerForCategory } from '@gonfalon/analytics/createTrackerForCategory';
import { track } from '@gonfalon/analytics/track';
import type { AnalyticEventData } from '@gonfalon/analytics/types';

export const trackManageMembersPage = createTrackerForCategory('Manage Member');
export const trackSelectAPlan = createTrackerForCategory('Select A Plan');
export const trackTeamSync = createTrackerForCategory('Team Sync');

// Team Sync Events
export const trackTeamSyncTurnOnButtonClicked = () => trackTeamSync('Turn on Button Clicked');
export const trackTeamSyncTurnOffButtonClicked = () => trackTeamSync('Turn off Button Clicked');
export const trackTeamSyncTurnOnConfirmationButtonClicked = () => trackTeamSync('Turn on Confirmation Button Clicked');
export const trackTeamSyncTurnOffConfirmationButtonClicked = () =>
  trackTeamSync('Turn off Confirmation Button Clicked');

// Account security configuration
export const trackAddMembersList = (attr: {
  url: string;
  component: string;
  type: 'button' | 'link';
  hasInviteMemberAccess?: boolean;
}) => trackManageMembersPage('Invite Members Button Clicked', attr);

export const trackRequestNewSeats = (attr: { url: string; component: string; type: 'button' | 'link' }) =>
  trackManageMembersPage('Request seats Button Clicked', attr);

export const trackCustomRoleSelected = () => trackManageMembersPage('Invite Members Dropdown Custom Role Selected');
export const trackInviteMembersModalOpened = () => trackManageMembersPage('Invite Members Modal Opened'); // TODO:
export const trackInviteMembersModalCancelButtonClicked = () =>
  trackManageMembersPage('Invite Members Cancel Button Clicked');
export const trackInviteMembersTeamDropdownClicked = () =>
  trackManageMembersPage('Invite Members Team Dropdown Option Clicked');

export const trackInvitedMembersList = (attr: {
  url: string;
  component: string;
  type: 'button' | 'link';
  referrer: string;
  initialRole: string;
  numberOfInvitedMembers: number;
  teamCount: number;
}) => trackManageMembersPage('New Member Invited', { ...attr });

export const trackChangeAccountOwners = (attr: { url: string; component: string; type: 'button' | 'link' }) =>
  trackManageMembersPage('Account Owner Changed', attr);

export const trackResendInvitation = (attr: { url: string; component: string; type: 'button'; email: string }) =>
  trackManageMembersPage('Invitation Resent', attr);

export const trackSelectAPlanClicked = (attr: {
  url: string;
  path: string;
  component: string;
  type: 'button' | 'href';
  cta: string;
}) => track('Select A Plan Clicked', 'Select A Plan', attr);

const trackSuggestInvite = createTrackerForCategory('SuggestInvite');
export const trackInviteSuggestionSubmitted = (attrs: AnalyticEventData) =>
  trackSuggestInvite('Invite suggestion submitted', attrs);
